import { render, staticRenderFns } from "./GoToInbox.vue?vue&type=template&id=942adfe2"
import script from "./GoToInbox.vue?vue&type=script&lang=ts"
export * from "./GoToInbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('942adfe2')) {
      api.createRecord('942adfe2', component.options)
    } else {
      api.reload('942adfe2', component.options)
    }
    module.hot.accept("./GoToInbox.vue?vue&type=template&id=942adfe2", function () {
      api.rerender('942adfe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/GoToInbox.vue"
export default component.exports